/* This file was generated automatically. Do not edit manually. */

export enum GuestInHouseReportReservationsDisplayOptions {
    Balance = 'Balance',
    AllProducts = 'AllProducts',
    ReservationNotes = 'ReservationNotes',
    CustomerNotes = 'CustomerNotes',
    CarRegistrationNumber = 'CarRegistrationNumber',
    ProductsConsumedInInterval = 'ProductsConsumedInInterval',
    Loyalty = 'Loyalty',
    CompanionLoyalty = 'CompanionLoyalty',
    Classifications = 'Classifications',
    VerificationPhoto = 'VerificationPhoto',
}
